<div class="flex h-full flex-grow items-center justify-center p-6 pt-20 xs:mb-14">
  <div class="flex flex-col items-center justify-center gap-4">
    <div class="flex w-16 flex-1 md:w-24">
      <pay-login-logo [width]="90" [height]="60"></pay-login-logo>
    </div>
    <span
      class="is-heading break-long-words is-lg group flex items-end self-center px-6 pb-5 text-center font-heading text-xl font-medium xs:text-xl sm:text-2xl lg:text-3xl">
      {{ 'logged-out.title' | translate }}
    </span>
    <div class="flex w-screen max-w-[500px] flex-col p-6">
      <p class="mt-1 text-center text-lg font-normal sm:text-xl">
        {{ 'logged-out.description' | translate }}
      </p>
    </div>
  </div>
</div>
